import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { ToastContainer, toast } from 'react-toastify';
import { savingToastSelector } from '../../../store/ui';

const WithSavingToastContainer = ({ children }) => {
  const savingToast = useSelector(savingToastSelector);
  useEffect(() => {
    if (savingToast.isOpen) {
      toast.info('Saving...', {
        delay: 0,
      });
    }
  }, [savingToast.isOpen]);
  return (
    <>
      {children}
      {savingToast.isOpen && (
        <ToastContainer
          position="top-center"
          autoClose={false}
          hideProgressBar={true}
          closeButton={false}
          draggable={false}
          containerId="with-saving"
        />
      )}
    </>
  );
};

export default WithSavingToastContainer;
